import React from 'react'
import { Pulse } from 'better-react-spinkit'
import { HeadingPrimary, Text } from 'Styles/Typography'
import { get, update, getTimestamp } from 'Services/Firebase'
import { compose, withState, lifecycle, withHandlers, branch, renderComponent } from 'recompose';
import { Button, Checkbox } from 'Components'
import {
  Terms,
  ClaimWrapper,
  CheckboxTerms,
  ActionsWrapper,
  AcceptTermMessage
} from './Styles'

const TnCs = ({ terms: { matchOfItems, inactivePolicy, excess }, status: { attempted }, onChangeTerms, onAcceptTerms }) => (
  <ClaimWrapper>
    <HeadingPrimary>Terms and conditions</HeadingPrimary>
    <Terms>
      <li>
        <Text>
          This document must only be completed when all <strong>Plumbing</strong> repairs have been satisfactorily concluded by the <strong>Plumber</strong> appointed to carry out the <strong>Plumbing</strong> portion of your claim. Please note that you may contact the <strong>Plumber</strong> should the plumbing work performed by them develop a malfunction.
        </Text>
      </li>
      <li>
        <Text>
          Your answers to the <strong>Service Questionnaire</strong> are monitored by the Insurer.
        </Text>
      </li>
      <li>
        <Text>
          Any insured item replaced such as geyser, valve, etc., is regarded as <strong>Salvage</strong> in terms of your policy and therefore is the property of the Insurer.
        </Text>
      </li>
      <li>
        <Text>
          It is common practice to leave the failed geyser in its current location, provided it is properly drained, this to avoid the dismantling the roof or other part of the building.
        </Text>
      </li>
      <li>
        <Text>
          By this notice, the Insured is informed that in terms of the Occupational Health and Safety Act 1993, it is the responsibility of the Insured to install an electrical <strong>Isolating Device</strong> in accordance with SANS 10142 at each operational Hot Water Cylinder on the premises. The Insurer takes no responsibility and will not be liable for any loss or damages caused to anyone or anything because of the absence of the isolating device.
        </Text>
      </li>
      <li>
        <Text>
          I, the policy holder, acknowledge that I have read, understood and accept the following policy conditions in terms of:
        </Text>
        <CheckboxTerms>
          <li>
            <div>
              <Checkbox sm selected={matchOfItems} onChange={() => onChangeTerms('matchOfItems')} />
              <strong>Matching of Items (check if applicable)</strong>
            </div>
            Reinstatement of tiles, sanitaryware or cupboards dismantled or broken to enable a plumbing repair, will be rectified using similar item(s) if the same item(s) are no longer available.
          </li>
          <li>
            <div>
              <Checkbox sm invalid={attempted && !inactivePolicy} selected={inactivePolicy} onChange={() => onChangeTerms('inactivePolicy')} />
              <strong>Inactive Policy</strong>
            </div>
            Should my insurance policy be inactive or the specific loss excluded, then I will be liable to pay the full amount due for the remedial plumbing work.
          </li>
          <li>
            <div>
              <Checkbox sm invalid={attempted && !excess} selected={excess} onChange={() => onChangeTerms('excess')} />
              <strong>Excess (First Amount Payable)</strong>
            </div>
            Should the incorrect excess be collected by the Service Provider, I will be liable to pay the total amount / shortfall as soon as my Insurer becomes aware of the omission/shortfall.
          </li>
        </CheckboxTerms>
      </li>
    </Terms>
    <ActionsWrapper>
      {attempted && <AcceptTermMessage>To continue please accept the terms and conditions.</AcceptTermMessage>}
      <Button onClick={onAcceptTerms}>
        Next >
      </Button>
    </ActionsWrapper>
  </ClaimWrapper>
)

const initialStatus = {
  loading: false,
  error: null,
  accepted: false,
  attempted: false
}

export default compose(
  withState('status', 'setStatus', initialStatus),
  withState('terms', 'setTerms', { matchOfItems: false, inactivePolicy: false, excess: false }),
  withHandlers({
    updateStatus: ({ status, setStatus }) => update => setStatus({ ...status, ...update })
  }),
  lifecycle({
    async componentDidMount () {
      const { match: { params: { claimId } }, history } = this.props
      this.props.updateStatus({ loading: true })
      const { value } = await get(`claims/${claimId}`);
      if (value && value.inactivePolicy) {
        history.push(`/claim/${claimId}/survey`)
      } else {
        update(`claims/${claimId}`, { linkOpenedAt: getTimestamp() });
      }
      this.props.updateStatus({ loading: false })
    }
  }),
  withHandlers({
    onChangeTerms: ({ terms, setTerms }) => field => setTerms({ ...terms, [field]: !terms[field] }),
    onAcceptTerms: ({ history, terms, updateStatus, match: { params: { claimId } = {} } = {} }) => async () => {
      try {
        if (terms.inactivePolicy && terms.excess) {
          const termsAcceptedFrom = await fetch('https://json.geoiplookup.io/').then(res => res.json())
          await update(`claims/${claimId}`, {
            ...terms,
            termsAcceptedFrom,
            termsAcceptedAt: getTimestamp()
          });
          history.push(`/claim/${claimId}/survey`)
        } else {
          updateStatus({ attempted: true });
        }
      } catch (error) {
        updateStatus({ accepted: false, error: error.message, attempted: false })
      }
    }
  }),
  branch(({ status: { loading } }) => loading, renderComponent(() => <Pulse color='rgb(7, 71, 166)' />))
)(TnCs)



// WEBPACK FOOTER //
// ./src/Containers/AcceptTermsContainer.jsx